import * as CONSTANTS from '../../constants';
import { post } from '../../utils/apiUtils';

function getAllOffersList() {
  return post(CONSTANTS.getAllOffersList, {});
}

export default getAllOffersList;
